import { useCallback } from "react";

// In a real app, this would come from env vars or a config service
const MFE_UI_LAYER_URL_MF =
  process.env.MFE_UI_LAYER_URL_MF || "http://localhost:3000"; // Module Federation URL (MFE dev server)
const MFE_UI_LAYER_URL_IFRAME =
  process.env.MFE_UI_LAYER_URL_IFRAME || "http://localhost:3000"; // Iframe URL (MFE dev server for iframe)

export function useHostConfig() {
  const getApiUrl = useCallback(() => {
    return "https://dhanaprayoga.fiu.finfactor.in/pfm/api/v2";
  }, []);

  const getMfeUiLayerUrl = useCallback((type: "mf" | "iframe") => {
    let url = type === "mf" ? MFE_UI_LAYER_URL_MF : MFE_UI_LAYER_URL_IFRAME;
    if (!url) {
      url = "http://localhost:3000";
    }
    // Remove surrounding quotes if they exist
    url = url.replace(/^"+|"+$/g, "");
    if (!/^https?:\/\//.test(url)) {
      url = "http://" + url;
    }
    return url;
  }, []);

  return { getApiUrl, getMfeUiLayerUrl };
}
